import { AxiosResponse } from 'axios';
import { IPermissions } from '../../interfaces/permission';
import PermissionsService from '../../Services/PermissionsService';
import { AuthGdprProfilesDTO, AuthCustomersDTO, AuthUserDTO } from './types';
import { getDefaultCustomer, setDefaultCustomer } from '../../Services/UserService';
import { getRequest } from '../../Services/HttpService';
import { ICustomer } from '../../store/recoil/customers';

export const getUserData = async (): Promise<AuthUserDTO | false | AxiosResponse<unknown, any>> => {
  return getRequest<AuthUserDTO>('v2/auth/user', {
    showErrorToaster: [500],
    showToaster: false,
  });
};

export const getGdprProfiles = async (): Promise<
  AuthGdprProfilesDTO | false | AxiosResponse<unknown, any>
> => {
  return getRequest<AuthGdprProfilesDTO>('v2/auth/gdpr-profiles', {
    showErrorToaster: false,
    showToaster: false,
  });
};

export const getCustomers = async (): Promise<
  AuthCustomersDTO | false | AxiosResponse<unknown, any>
> => {
  return getRequest<AuthCustomersDTO>('v2/auth/customers', {
    showErrorToaster: false,
    showToaster: false,
  });
};

export const setPermissions = (data: AuthCustomersDTO): void => {
  const permissions: IPermissions = {};
  const customerIds = Object.keys(data);
  customerIds.map((customerId: string) => {
    Object.keys(data[Number(customerId)].permissions).forEach((key: string) => {
      permissions[Number(customerId)] = {
        ...permissions[Number(customerId)],
        [data[Number(customerId)].permissions[key].code]: {
          ...data[Number(customerId)].permissions[key],
        },
      };
    });
  });
  PermissionsService.save(permissions);
};

export const createCustomersArray = (data: AuthCustomersDTO): ICustomer[] => {
  return Object.keys(data).map((key: string) => {
    const customerId: number = Number(key);
    const customerItem: ICustomer = {
      id: data[customerId].id,
      name: data[customerId].name,
      shortName: data[customerId].shortName,
      label: data[customerId].shortName,
      salesChannel: {
        id: data[customerId].salesChannelId,
        shortName: data[customerId].salesChannelShortName,
      },
      default_currency: data[customerId].currency,
      default_tax_percentage: data[customerId].vat,
    };
    return customerItem;
  });
};

export const createCustomerIdsArray = (customers: ICustomer[]) => {
  return customers.map((customer: ICustomer) => customer.id);
};

export const removeUnusedCustomersFromDefaultCustomers = (customerIds: number[]): number[] => {
  const defaultCustomers: number[] = getDefaultCustomer();
  const newDefaultCustomers: number[] = defaultCustomers.filter((customerId: number) =>
    customerIds.includes(customerId)
  );
  setDefaultCustomer(newDefaultCustomers);
  return newDefaultCustomers;
};
